module.exports = __webpack_public_path__ + "static/img/0545_4.b1b98b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_4.jpg
// module id = SK9u
// module chunks = 1